/**
 * Team members data
 * Used in Team section and Team page
 */
export const teamMembers = [
  {
    id: 1,
    name: "Deni Mišlov",
    title: "CEO / Lead Software Engineer",
    summary: "Oversees company direction and leads development of automation software.",
    image: "/img/deni-mislov-new.jpg",
    social: { linkedin: "https://hr.linkedin.com/in/deni-mi%C5%A1lov-gi" }
  },
  {
    id: 2,
    name: "Đani Kurić",
    title: "CTO / Lead Software Engineer",
    summary: "Manages technical strategy and guides the engineering team.",
    image: "/img/dani-kuric-new.jpg",
    social: { linkedin: "https://hr.linkedin.com/in/%C4%91ani-kuri%C4%87-92214099" }
  },
  {
    id: 4,
    name: "Karlo Crnčec",
    title: "Senior Engineer",
    summary: "Integrates systems and ensures reliable communication across projects.",
    image: "/img/karlo-crncec-new.jpg",
    social: { linkedin: "https://www.linkedin.com/in/karlo-crncec-9b37991a7/" }
  },
  {
    id: 3,
    name: "Roko Košta",
    title: "Senior Engineer",
    summary: "Develops software solutions and supports system deployments.",
    image: "/img/roko-kosta-new.jpg",
    social: { linkedin: "https://hr.linkedin.com/in/rokosta" }
  },
  {
    id: 5,
    name: "Filip Milutin",
    title: "Senior Engineer / Lead of Transport and Warehouse Technology Department",
    summary: "Leads the transport and warehouse technology team and develops user-friendly solutions.",
    image: "/img/filip-milutin-new.jpg",
    social: { linkedin: "https://www.linkedin.com/in/filip-milutin-399365229/" }
  },
  {
    id: 6,
    name: "Paula Skorić",
    title: "Head of Administration",
    summary: "Manages administrative operations and supports project coordination.",
    image: "/img/paula-skoric-new2.jpg",
    social: { linkedin: "https://hr.linkedin.com/in/paula-skori%C4%87-62881b61" }
  },
  {
    id: 7,
    name: "Josip Perinčić",
    title: "Software Engineer",
    summary: "Optimizes processes and integrates mechanical systems to enhance efficiency.",
    image: "/img/josip-perincic-new.jpg",
    social: { linkedin: "https://hr.linkedin.com/in/josipperincic" }
  },
  {
    id: 8,
    name: "Marko Klapan",
    title: "Software Engineer",
    summary: "Coordinates projects and develops software to deliver automation solutions.",
    image: "/img/marko-klapan-new.jpg",
    social: { linkedin: "https://hr.linkedin.com/in/marko-klapan-813ab422a" }
  },
  {
    id: 9,
    name: "Lučano Čiklić",
    title: "Robot Programmer",
    summary: "Programs and configures robots to support automated processes.",
    image: "/img/luciano-ciklic-new.jpg",
    social: { linkedin: "https://linkedin.com/in/lucano-ciklic" }
  },
  {
    id: 10,
    name: "Frane Šango",
    title: "Software Engineer",
    summary: "Tests and validates software to maintain high quality standards.",
    image: "/img/frane-sango-new.jpg",
    social: { linkedin: "https://www.linkedin.com/in/frane-sango-a3357b17/" }
  },
  {
    id: 11,
    name: "Dejan Stanković",
    title: "Junior Software Engineer",
    summary: "Assists with development tasks and contributes innovative ideas.",
    image: "/img/dejan-stankovic-new.jpg",
    social: { linkedin: "https://linkedin.com/in/dejan-stankovic" }
  },
  {
    id: 12,
    name: "Daniel Dražić",
    title: "Junior Software Engineer",
    summary: "Supports system integration and learns to develop automation platforms.",
    image: "/img/daniel-drazic-new.jpg",
    social: { linkedin: "https://linkedin.com/in/daniel-drazic" }
  },
  {
  id: 13,
  name: "Marko Gunja",
  title: "PLC Programmer",
  summary: "Specializes in programming, testing, and optimizing PLC systems for industrial automation projects.",
  image: "/img/marko-gunja.jpg",
  social: { linkedin: "https://www.linkedin.com/in/marko-gunja-471961108/?originalSubdomain=hr" }
}

];
